import React, {Component} from 'react'
import {useLocation, matchPath, useNavigate} from 'react-router-dom'
import {FButton, FSelect, FInput, Renderless, FView, FText} from 'f-web-app/components'
import {dispatch} from 'f-web-app/store'
import {isEqual, isEmpty} from 'lodash'
import {ThemeContext} from 'f-web-app'

const STATES = {
  ENTER_EMAIL: {
    verifyingEmail: false,
    emailExistConfirmed: false,
    emailDontExistConfirmed: false,
  },
  CHECKING_EMAIL: {
    verifyingEmail: true,
    emailExistConfirmed: false,
    emailDontExistConfirmed: false,
  },
  EMAIL_LOCKED_ENTER_PASS: {
    verifyingEmail: false,
    emailExistConfirmed: true,
    emailDontExistConfirmed: false,
  },
  REGISTER_ENTER_EMAIL_AND_PASS: {
    verifyingEmail: false,
    emailExistConfirmed: false,
    emailDontExistConfirmed: true,
  },
}

class Auth extends Component {
  state = STATES.ENTER_EMAIL
  emailInput = React.createRef()
  passInput = React.createRef()
  nameInput = React.createRef()
  phoneInput = React.createRef()
  render() {
    return (
      <>
        <FSelect selector={dispatch.user.getIsLoggedIn}>
          <Renderless
            componentDidMount={() => {
              this._handleNextRoute()
            }}
          />
        </FSelect>
        <ThemeContext.Consumer>
          {({themeColors, Auth}) => (
            <Auth.AuthView
              GoBackButtonElement={
                (this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS) ||
                  this._isState(STATES.EMAIL_LOCKED_ENTER_PASS)) && (
                  <FButton onClick={() => this.setState(STATES.ENTER_EMAIL)}>
                    <Auth.GoBackButtonView />
                  </FButton>
                )
              }
              EmailInputElement={
                <FInput
                  disabled={!this._isState(STATES.ENTER_EMAIL)}
                  ref={this.emailInput}
                  onKeyPress={this._handleKeyPress}
                  {...Auth.emailInputProps}
                />
              }
              PasswordInputElement={
                (this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS) ||
                  this._isState(STATES.EMAIL_LOCKED_ENTER_PASS)) && (
                  <FInput
                    autoFocus
                    disabled={this._isState(STATES.CHECKING_EMAIL)}
                    type="password"
                    ref={this.passInput}
                    onKeyPress={this._handleKeyPress}
                    {...Auth.passwordInputProps}
                  />
                )
              }
              NameInputElement={
                this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS) && (
                  <FInput
                    ref={this.nameInput}
                    maxLength="18"
                    onKeyPress={this._handleKeyPress}
                    {...Auth.nameInputProps}
                  />
                )
              }
              PhoneInputElement={
                this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS) && (
                  <FInput
                    ref={this.phoneInput}
                    maxLength="10"
                    onKeyPress={this._handleKeyPress}
                    {...Auth.phoneInputProps}
                  />
                )
              }
              NextButtonElement={
                (this._isState(STATES.ENTER_EMAIL) || this._isState(STATES.CHECKING_EMAIL)) && (
                  <FButton disabled={this._isState(STATES.CHECKING_EMAIL)} onClick={this._handleEmailEnter}>
                    <Auth.NextButtonView isCheckingEmail={this._isState(STATES.CHECKING_EMAIL)} />
                  </FButton>
                )
              }
              TermsAndConditionsElement={
                this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS) &&
                (Auth.TermsAndConditions ? (
                  <Auth.TermsAndConditions />
                ) : (
                  <FView fontSize={14} row lightGrey>
                    <FText lightGrey>
                      By Signing Up, you agree to our
                      <a style={{marginLeft: 6, color: themeColors.primary}} href="https://foodly.ca/terms">
                        Terms & Conditions
                      </a>
                    </FText>
                  </FView>
                ))
              }
              LoginButtonElement={
                (this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS) ||
                  this._isState(STATES.EMAIL_LOCKED_ENTER_PASS)) && (
                  <FSelect selector={dispatch.user.getIsLoggingIn}>
                    {(isLoggingIn) => {
                      if (this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS)) {
                        return (
                          <FButton disabled={isLoggingIn} onClick={this._handleSignUp}>
                            <Auth.SignupButtonView isLoggingIn={isLoggingIn} />
                          </FButton>
                        )
                      } else if (this._isState(STATES.EMAIL_LOCKED_ENTER_PASS)) {
                        return (
                          <FButton disabled={isLoggingIn} onClick={this._handleLogin}>
                            <Auth.LoginButtonView isLoggingIn={isLoggingIn} />
                          </FButton>
                        )
                      }
                    }}
                  </FSelect>
                )
              }
              ForgotPasswordButtonElement={
                !this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS) && <Auth.ForgotPasswordButton />
              }
            />
          )}
        </ThemeContext.Consumer>
      </>
    )
  }
  _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (this._isState(STATES.ENTER_EMAIL)) {
        this._handleEmailEnter(e)
      } else if (this._isState(STATES.EMAIL_LOCKED_ENTER_PASS)) {
        this._handleLogin(e)
      } else if (this._isState(STATES.REGISTER_ENTER_EMAIL_AND_PASS)) {
        this._handleSignUp(e)
      }
    }
  }
  _handleEmailEnter = (e) => {
    e.preventDefault()
    this.setState(STATES.CHECKING_EMAIL)
    dispatch.user
      .getIsEmailExists(this.emailInput.current.value)
      .then((res) => {
        if (res) {
          this.setState(STATES.EMAIL_LOCKED_ENTER_PASS)
        } else {
          this.setState(STATES.REGISTER_ENTER_EMAIL_AND_PASS)
        }
      })
      .catch((e) => {
        dispatch.notification.setMessage({message: e.message, level: 'error'})
        this.setState(STATES.ENTER_EMAIL)
      })
  }
  _handleLogin = (e) => {
    e.preventDefault()
    const email = this.emailInput.current.value
    const password = this.passInput.current.value
    dispatch.user
      .signInWithEmailAndPassword({
        email,
        password,
      })
      .then((res) => {
        this._handleNotificationAndSetCart()
      })
      .catch((e) => {
        dispatch.notification.setMessage({message: e.message, level: 'error'})
      })
  }
  _handleSignUp = (e) => {
    e.preventDefault()
    const email = this.emailInput.current.value
    const password = this.passInput.current.value
    const name = this.nameInput.current.value
    const phoneNumber = this.phoneInput.current.value
    dispatch.user
      .createUserWithEmailAndPassword({
        email,
        password,
        name,
        phoneNumber,
      })
      .then((res) => {
        this._handleNotificationAndSetCart()
      })
      .catch((e) => {
        dispatch.notification.setMessage({message: e.message, level: 'error'})
      })
  }
  _handleNotificationAndSetCart = () => {
    const email = dispatch.user.getEmail()
    dispatch.notification.setMessage({
      message: `Welcome! ${email}`,
      level: 'success',
    })
    const cart = dispatch.user.getCart()
    if (!isEmpty(cart)) {
      dispatch.user.setCart(cart)
    }
  }
  _handleNextRoute = () => {
    const {navigate, location} = this.props
    const matches = matchPath('/auth/:nextRoute/:nextRoute2?', location.pathname)
    const {nextRoute, nextRoute2} = matches.params
    navigate(`/${nextRoute}` + (nextRoute2 ? `/${nextRoute2}` : ''))
  }
  _isState(state) {
    return isEqual(this.state, state)
  }
}

export default function AuthWithRouter() {
  const navigate = useNavigate()
  const location = useLocation()
  return <Auth navigate={navigate} location={location} />
}
